import { useState, useEffect, useRef, memo } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdLocalPhone,
} from "react-icons/md";
import emailjs from "emailjs-com";
import { AnimatePresence } from "framer-motion";
import ContactForm from "../pages/Contactus";
import logoimg from "../../assets/logoimg.png";
import { courseList } from "../../data/navigationData";
import { tsTaskList } from "../../Tasks/ts_tasks/routes/tsNavigationData";
import { Popup, CourseDropdown } from "./NavSubComponents";

const TabNavigation = () => {
  const navigate = useNavigate();
  const [showOptions, setShowOptions] = useState(false);
  const [showTaskOptions, setShowTaskOptions] = useState(false);
  const [showAutoPopup, setShowAutoPopup] = useState(false);
  const [showClickPopup, setShowClickPopup] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const form = useRef();
  const dropdownRef = useRef(null);
  const navRef = useRef(null);

  useEffect(() => {
    if (showAutoPopup || showClickPopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showAutoPopup, showClickPopup]);

  useEffect(() => {
    const timer = setTimeout(() => setShowAutoPopup(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowOptions(false);
        setShowTaskOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (navRef.current) {
        const navTop = navRef.current.offsetTop;
        setIsFixed(window.scrollY > navTop);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_bola37k",
        "template_nj7chwl",
        form.current,
        "PpxbC7N3MNQYk25Qx",
      )
      .then(
        () => {
          alert("Message sent successfully!");
          form.current.reset();
        },
        (error) => {
          alert("Failed to send message.");
          console.error(error.text);
        },
      );
  };

  return (
    <div className={`bg-zinc-100 p-3 sm:p-4 overflow-x-hidden ${isFixed ? "mt-16" : ""}`}>
      {/* Popups */}
      <AnimatePresence>
        {showAutoPopup && (
          <Popup onClose={() => setShowAutoPopup(false)}>
            <h2 className="text-xl font-bold text-gray-800 mb-2 text-center">SAR Placement Technologies</h2>
            <p className="text-gray-600 mb-4 text-center">Register for a Free Online Demo Class on Flutter</p>
            <div className="flex justify-center">
              <button
                onClick={() => { setShowAutoPopup(false); setShowClickPopup(true); }}
                className="bg-gradient-to-r from-red-500 to-pink-500 text-white py-2 px-5 rounded-lg font-medium shadow-md"
              >
                Register For Free Demo
              </button>
            </div>
          </Popup>
        )}
        {showClickPopup && (
          <Popup onClose={() => setShowClickPopup(false)}>
            <h2 className="text-xl font-bold text-gray-800 mb-4 uppercase">Contact Us</h2>
            <ContactForm formRef={form} sendEmail={sendEmail} />
            <div className="mt-4 p-4 bg-black text-white rounded-lg text-sm">
              <h3 className="border-b pb-1">Have Queries? Ask Our Experts</h3>
              <div className="flex items-center gap-2 mt-2">
                <MdLocalPhone className="text-xl" />
                <div>
                  <p>+91 824 816 2712</p>
                  <p>Available 24x7 for your queries</p>
                </div>
              </div>
            </div>
          </Popup>
        )}
      </AnimatePresence>

      {/* Navbar */}
      <div
        ref={(el) => { navRef.current = el; dropdownRef.current = el; }}
        className={`bg-gradient-to-r from-blue-800 to-purple-800 text-white py-3 px-4 sm:px-8 shadow-2xl transition-all duration-300 ${
          isFixed ? "fixed top-0 left-0 right-0 z-[100] rounded-none" : "rounded-2xl mt-2 mx-1 sm:mx-4"
        }`}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {isFixed && <img src={logoimg} alt="SAR Logo" className="w-12 h-12 object-contain rounded-md" />}

          <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-sm sm:text-base font-semibold">
            <span onClick={() => navigate("/")} className="cursor-pointer rounded-lg px-2 py-2 transition-colors hover:bg-white/10 hover:underline">Home</span>
            <span onClick={(e) => { e.stopPropagation(); setShowOptions(!showOptions); setShowTaskOptions(false); }} className="flex cursor-pointer items-center gap-1 rounded-lg px-2 py-2 transition-colors hover:bg-white/10 hover:underline">
              Courses {showOptions ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </span>
            <span onClick={() => setShowClickPopup(true)} className="cursor-pointer rounded-lg px-2 py-2 transition-colors hover:bg-white/10 hover:underline">Contact Us</span>
            {/* <span onClick={(e) => { e.stopPropagation(); setShowTaskOptions(!showTaskOptions); setShowOptions(false); }} className="cursor-pointer flex items-center gap-1 hover:underline">
              Daily Tasks {showTaskOptions ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </span> */}
          </div>

          <div className="hidden sm:block">
            <button onClick={() => setShowClickPopup(true)} className="rounded-full bg-white px-4 py-2 text-sm font-bold text-purple-800 shadow-md transition hover:bg-opacity-90 sm:px-5 sm:text-base">
              Enrol Now
            </button>
          </div>
        </div>
      </div>

      {/* Dropdowns */}
      <AnimatePresence>
        {showOptions && <CourseDropdown courseList={courseList} onSelect={(route) => { navigate(route); setShowOptions(false); }} />}
        {showTaskOptions && <CourseDropdown courseList={tsTaskList} onSelect={(route) => { navigate(route); setShowTaskOptions(false); }} />}
      </AnimatePresence>
    </div>
  );
};

export default memo(TabNavigation);
